const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_pages/$lang/_legal/terms/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { alternatesToLinks, buildLocalizedPageAlternates } from "@/i18n/alternates";
import { buildPagePreviewMetaTags } from "@/lib/buildPagePreviewMetaTags";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_pages/$lang/_legal/terms/")({
  head: async ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const t = createTranslator({
      locale,
      messages,
      namespace: "globals.legal"
    });
    const alts = buildLocalizedPageAlternates(locale, "terms");
    return {
      meta: await buildPagePreviewMetaTags({
        title: t("termsTitle"),
        description: t("termsDescription"),
        canonicalUrl: alts.canonical
      }, {}, {
        locale
      }),
      links: alternatesToLinks(alts)
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});